const t=e=>!!(typeof e=="function"?e():e);export{t as getConditionResult};
